import React, { useEffect, useState } from "react";
import UserHeader from "./components/UserHeader";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import ShowRouting from "../../components/ShowRouting";
import UserTab from "./components/UserTab";
import { Container } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import _ from "lodash";
import { getUserById, getUserReviews } from "../../apis";

const UserDetails = () => {
  const navigate = useNavigate();
  let { id } = useParams();
  const [userData, setUserData] = useState([]);
  const [userReviews, setUserReviews] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      let response = await getUserById(id);
      let reviewsResponse = await getUserReviews(id);
      setUserData(response.data);
      setUserReviews(reviewsResponse.data.reviewsData);
    };
    fetchData();
  }, []);
  useEffect(() => {
    let user = {};
    user = JSON.parse(localStorage.getItem("user-info"));
    if (_.isEmpty(user)) {
      navigate("/login");
    }
  }, []);
  return (
    <div>
      <Navbar />
      {userData?.user && (
        <>
          <UserHeader
            name={userData.user.fullName}
            country={userData.user.country}
            picture={userData.serviceProviderInfo.personalInfo.image[0]}
            reviews={userReviews}
            rating={userData.serviceProviderInfo.personalInfo.avgRating}
          />
          <Container className="mt-16 mb-16">
            <UserTab
              info={userData.serviceProviderInfo}
              reviews={userReviews}
            />
          </Container>
          <Footer />
        </>
      )}
    </div>
  );
};

export default UserDetails;
